import {Abilities, Skills} from '../../../../components/enums';
import type {Ability} from '../../../../generated/types';
import type {OriginData, OriginToolChoice} from '../model/catalog';

type OriginSource = {
	id: string;
	title: string;
	abilities: string;
	skills: string;
	instruments: string;
	equipment?: string | null;
	featId?: string;
	featVariant?: string;
	featCategory?: string;
};

const invert = (labels: Record<string, string>) =>
	Object.fromEntries(Object.entries(labels).map(([key, label]) => [label.toLowerCase(), key]));

const ABILITY_BY_LABEL = invert(Abilities);
const SKILL_BY_LABEL = invert(Skills);

const TOOL_CHOICE_PATTERNS: [RegExp, OriginToolChoice][] = [
	[/музыкальн/i, 'instrument'],
	[/игров|настольн/i, 'gamingSet'],
	[/ремесленник/i, 'tool'],
];

const ITEM_REFERENCE = /\{@item\s+([^,}]+)/;

const splitList = (text: string) =>
	text
		.split(/,|\sи\s/)
		.map((part) => part.trim().toLowerCase())
		.filter(Boolean);

export function parseOrigin(source: OriginSource): OriginData {
	const toolId = source.instruments.match(ITEM_REFERENCE)?.[1].trim();
	return {
		id: source.id,
		title: source.title,
		abilities: splitList(source.abilities)
			.map((label) => ABILITY_BY_LABEL[label])
			.filter(Boolean) as Ability[],
		skills: splitList(source.skills)
			.map((label) => SKILL_BY_LABEL[label])
			.filter(Boolean),
		toolId,
		toolChoice: toolId
			? undefined
			: TOOL_CHOICE_PATTERNS.find(([pattern]) => pattern.test(source.instruments))?.[1],
		featId: source.featId,
		featVariant: source.featVariant,
		equipment: source.equipment || undefined,
		featCategory: source.featCategory,
	};
}
